import FileUploadApi from './FileUploadApi';
import HttpService from './HttpService';

const SafetyObservationApi = HttpService('/api/safetyobservations/');
const doGet = (url) => SafetyObservationApi.get(url);
const doPost = (action, data) => SafetyObservationApi.post(action, data);
const doPut = (action, data) => SafetyObservationApi.put(action, data);
const doDelete = (url) => SafetyObservationApi.delete(url);

export default {
  getSafetyObservationsForVoyage(voyageReportId) {
    const apiAction = 'GetSafetyObservationsForVoyage';
    const url = voyageReportId ? `${apiAction}?voyageReportId=${voyageReportId}` : apiAction;
    return doGet(url);
  },
  createSafetyObservation(safetyObservation) {
    const apiAction = 'CreateSafetyObservation';
    return doPost(apiAction, safetyObservation);
  },
  updateSafetyObservation(updatedSafetyObservation) {
    const apiAction = 'UpdateSafetyObservation';
    return doPut(apiAction, updatedSafetyObservation);
  },
  deleteSafetyObservation(id) {
    const apiAction = 'DeleteSafetyObservation';
    const url = id ? `${apiAction}?id=${id}` : apiAction;
    return doDelete(url);
  },
  getPhotoFileUrl(fileName, safetyObservation) {
    return `safetyobservations/GetImage?safetyObservationId=${safetyObservation.id}&fileName=${encodeURIComponent(fileName)}`;
  },
  uploadPhoto(file, safetyObservation) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("id", safetyObservation.id);
    return FileUploadApi().post("safetyobservations/UploadImage", formData);
  },
  deletePhoto(fileName, safetyObservation) {
    return doDelete(`DeleteImage?safetyObservationId=${safetyObservation.id}&fileName=${encodeURIComponent(fileName)}`);
  }
};
